"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssetClassNames = exports.AssetTypes = void 0;
var AssetTypes;
(function (AssetTypes) {
    AssetTypes["desk"] = "desk";
    AssetTypes["room"] = "room";
    AssetTypes["zone"] = "zone";
    AssetTypes["space_sc"] = "\u0E1E\u0E37\u0E49\u0E19\u0E17\u0E35\u0E48";
})(AssetTypes = exports.AssetTypes || (exports.AssetTypes = {}));
var AssetClassNames;
(function (AssetClassNames) {
    AssetClassNames["BUILDING"] = "building";
    AssetClassNames["FLOOR"] = "floor";
    AssetClassNames["AREA"] = "area";
    AssetClassNames["ROOM"] = "room";
    AssetClassNames["EVENT_SPACE"] = "event space";
    AssetClassNames["DESK"] = "desk";
    AssetClassNames["BUILDING_SC"] = "\u0E15\u0E36\u0E01\u0E41\u0E16\u0E27\u0E2B\u0E23\u0E37\u0E2D\u0E04\u0E39\u0E2B\u0E32";
    AssetClassNames["ZONE_SC"] = "\u0E2D\u0E32\u0E04\u0E32\u0E23\u0E1E\u0E32\u0E13\u0E34\u0E0A\u0E22\u0E4C";
    AssetClassNames["ALLEY_SC"] = "\u0E2D\u0E37\u0E48\u0E19 \u0E46";
    AssetClassNames["MARKET_SC"] = "\u0E15\u0E25\u0E32\u0E14";
    AssetClassNames["DEPARTMENT_STORE_SC"] = "\u0E2B\u0E49\u0E32\u0E07";
    AssetClassNames["SPACE_SC"] = "\u0E1E\u0E37\u0E49\u0E19\u0E17\u0E35\u0E48";
    AssetClassNames["GAS_STATION_SC"] = "\u0E1B\u0E31\u0E4A\u0E21\u0E19\u0E49\u0E33\u0E21\u0E31\u0E19";
    AssetClassNames["COMMUNITY_MALL"] = "Community Mall";
    AssetClassNames["OFFICE_BUILDING"] = "Office Building";
    AssetClassNames["SPECIALTY_STORE"] = "Specialty Store";
    AssetClassNames["SELL_DIVISION_OR"] = "\u0E2A\u0E48\u0E27\u0E19\u0E02\u0E32\u0E22";
    AssetClassNames["SELL_ZONE_OR"] = "\u0E40\u0E02\u0E15\u0E02\u0E32\u0E22";
    AssetClassNames["PROVINCE_INSIDE_OR"] = "\u0E08\u0E31\u0E07\u0E2B\u0E27\u0E31\u0E14 (\u0E20\u0E32\u0E22\u0E43\u0E19)";
    AssetClassNames["AMPHOE_OR"] = "\u0E2D\u0E33\u0E40\u0E20\u0E2D";
    AssetClassNames["STATION_OR"] = "\u0E2A\u0E16\u0E32\u0E19\u0E35";
})(AssetClassNames = exports.AssetClassNames || (exports.AssetClassNames = {}));
//# sourceMappingURL=assetTypes.js.map